import { Component, EventEmitter, Input, Output } from '@angular/core';
import { DatasetColumn } from '../select-datasource-modal.model';

@Component({
  selector: 'app-dataset-column-table',
  standalone: false,
  templateUrl: './dataset-column-table.component.html',
  styleUrl: './dataset-column-table.component.scss'
})
export class DatasetColumnTableComponent {
  @Input() columns: DatasetColumn[] = [];
  @Input() loading = false;
  @Output() selectionChanged = new EventEmitter<void>();

  searchTerm = '';

  get filteredColumns(): DatasetColumn[] {
    const term = this.searchTerm.trim().toLowerCase();
    if (!term) {
      return this.columns;
    }
    return this.columns.filter(column =>
      (column.name || '').toLowerCase().includes(term) ||
      (column.description || '').toLowerCase().includes(term)
    );
  }

  trackByColumnKey(_: number, column: DatasetColumn): string {
    return column.key;
  }

  onSelectionChanged(): void {
    this.selectionChanged.emit();
  }
}
